module.exports = __webpack_public_path__ + "img/seaDefuserTroop.c928fe52.png";